import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations'
import { NavService } from 'src/app/services/nav.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.8s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('0.3s', style({ opacity: 1 })),
      ]),
    ])
  ]
})
export class MapComponent implements OnInit {
  public pins: HTMLCollection
  public metaMessage: string = null
  public locations = [
    {
      'slug': 'drysdale',
      'developmentTitle': 'McLeods Drysdale',
      'message': '14km from Geelong, Victoria'
    },
    {
      'slug': 'aberdeen',
      'developmentTitle': 'Aberdeen',
      'message': '14km from Bendigo, Victoria'
    },
    {
      'slug': 'hinterland',
      'developmentTitle': 'Hinterland',
      'message': '14km from Bendigo, Victoria'
    },
    {
      'slug': 'fyansford',
      'developmentTitle': 'Fyansford',
      'message': '14km from Bendigo, Victoria'
    },
    {
      'slug': 'allure',
      'developmentTitle': 'Allure',
      'message': '14km from Bendigo, Victoria'
    },
    {
      'slug': 'eastern-ash',
      'developmentTitle': 'Eastern Ash',
      'message': '14km from Bendigo, Victoria'
    },
    {
      'slug': 'mervue',
      'developmentTitle': 'Mervue',
      'message': '14km from Bendigo, Victoria'
    }
  ]

  @ViewChild('map', {static: false}) svgMap: any;
  @Input() headline: string
  @Input() copy: string
  @Input() _editable: any
  constructor(
    private nav: NavService
  ) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupPins()
    }, 200)
  }

  setupPins() {
    let timeout
    for(let location of this.locations ) {
      const pin = document.getElementById(location.slug)
      const pulsePin = document.getElementById(`${location.slug}_pulse`)
      const logo = `../../../assets/development-logos/${location.slug}.svg`

      pin.addEventListener('mouseenter', () => {
        this.metaMessage = `<img class="logo" src="${logo}" />`
        pulsePin.classList.add('active')

        clearTimeout(timeout)
      })

      pin.addEventListener('mouseleave', () => {
        pulsePin.classList.remove('active')

        timeout = setTimeout(() => {
          this.metaMessage = null
        }, 1000)
      })
    }
  }

  flashPins() {
    console.log('flashing pins');
    let index = 0

    const pulses = document.getElementsByClassName('pulse')

    for (let i = 0; i < pulses.length; i++) {
      pulses[i].classList.add('active');
    }

    setTimeout(() => {
      for(let location of this.locations ) {
        const pulsePin = document.getElementById(`${location.slug}_pulse`)
        const time = 200 * index
    
        setTimeout(() => {
          pulsePin.classList.remove('active')
        }, time)
  
        index++
      }
    }, 2000)
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
